module.exports = __webpack_public_path__ + "static/media/esa1.856129df.jpg";